import React, { useState } from 'react'
import { DateRangePicker, DefinedRange } from 'react-date-range'
import moment from 'moment'
import {
  $DCprimaryColor,
  ButtonsGroup,
  PixelButton,
  PixelDropDown,
  PixelModal,
} from 'pixel-base'
import Offcanvas from 'react-bootstrap/Offcanvas'
import styled from 'styled-components'
import FilterIcon from 'utils/icons/filter-icon'

const DashboardMobileFilters = ({
  filters,
  setFilters,
  handleSubmit,
  themes,
  activeTheme,
  setActiveTheme,
}) => {
  const [show, setShow] = useState(false)
  const [showDateModal, setshowDateModal] = React.useState(false)

  const handleClose = () => setShow(false)
  const handleShow = () => setShow(true)

  return (
    <>
      <PixelButton onClick={handleShow}>
        <FilterIcon size={18} />
      </PixelButton>

      <Offcanvas show={show} onHide={handleClose} placement={'end'}>
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Filters</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Form>
            <ButtonsGroup>
              <PixelButton
                active={filters.data_type === 'daily' && 'active'}
                onClick={() =>
                  setFilters({
                    ...filters,
                    data_type: 'daily',
                  })
                }
              >
                Daily
              </PixelButton>

              <PixelButton
                active={filters.data_type === 'monthly' && 'active'}
                onClick={() =>
                  setFilters({
                    ...filters,
                    data_type: 'monthly',
                  })
                }
              >
                Monthly
              </PixelButton>
            </ButtonsGroup>
            <ThemeSwitch>
              <PixelDropDown
                selectlabel={'Change Theme'}
                options={Object.keys(themes).map((item) => {
                  return {
                    label: item,
                    value: item,
                  }
                })}
                value={activeTheme}
                onChange={(e) => {
                  setActiveTheme(e.target.value)
                }}
              />
            </ThemeSwitch>
            <DefinedRange
              onChange={(item) => {
                if (
                  moment(item.selection.startDate).format('MM-DD-YYYY') !==
                  moment(item.selection.endDate).format('MM-DD-YYYY')
                ) {
                  setshowDateModal(false)
                } else if (
                  item.selection.startDate === '' &&
                  item.selection.endDate === ''
                ) {
                  setshowDateModal(false)
                }
                setFilters({
                  ...filters,
                  start_date: new Date(item.selection.startDate),
                  end_date: new Date(item.selection.endDate),
                })
              }}
              showSelectionPreview={true}
              moveRangeOnFirstSelection={false}
              months={2}
              ranges={[
                {
                  startDate: new Date(filters.start_date),
                  endDate: new Date(filters.end_date),
                  key: 'selection',
                },
              ]}
              direction="horizontal"
            />
            <PixelButton
              onClick={() => {
                handleSubmit()
                handleClose()
              }}
              margin="10px"
            >
              Update
            </PixelButton>
          </Form>
        </Offcanvas.Body>
      </Offcanvas>
      {showDateModal && (
        <PixelModal
          title={''}
          size={{
            width: '950px !important',
            maxWidth: '100% !important',
          }}
          handleClose={() => setshowDateModal(false)}
          show={showDateModal}
        >
          <DateRangePicker
            rangeColors={[$DCprimaryColor]}
            onChange={(item) => {
              if (
                moment(item.selection.startDate).format('MM-DD-YYYY') !==
                moment(item.selection.endDate).format('MM-DD-YYYY')
              ) {
                setshowDateModal(false)
              } else if (
                item.selection.startDate === '' &&
                item.selection.endDate === ''
              ) {
                setshowDateModal(false)
              }
              setFilters({
                ...filters,
                start_date: moment(item.selection.startDate).format(
                  'YYYY-MM-DD',
                ),
                end_date: moment(item.selection.endDate).format('YYYY-MM-DD'),
              })
            }}
            showSelectionPreview={true}
            moveRangeOnFirstSelection={false}
            months={2}
            ranges={[
              {
                startDate: new Date(filters.start_date),
                endDate: new Date(filters.end_date),
                key: 'selection',
              },
            ]}
            direction="horizontal"
          />
        </PixelModal>
      )}
    </>
  )
}

const Form = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
`
const ThemeSwitch = styled.div`
  width: 225px;
`
export default DashboardMobileFilters
